import React, { Component } from 'react';
// import '../assets/lib/kakao.min'
import naverbtn from "../assets/image/naver_login_btn.png";
import '../assets/css/component/SocialLoginButtons.css';
import writeNew from "../assets/image/writeNew.png";


type Props = {
	onLoginSuccess: (token: string) => void;
};

class SocialLoginButtons extends Component<Props> {

	private naverLogin: any;

	componentDidMount() {
		// Kakao SDK 초기화
		if ((window as any).Kakao && !(window as any).Kakao.isInitialized()) {
			(window as any).Kakao.init('959cbe81fb1a3cc976ff0e3babed611f');
		}

		// 네이버 SDK가 로드될 때까지 기다림
		const initNaver = () => {
			if ((window as any).naver) {

				const callbackUrl = `${window.location.origin}/naver-callback`;

				this.naverLogin = new (window as any).naver.LoginWithNaverId({
					clientId: 'O8mga_4304ctxz_c4Vlm',
					callbackUrl: callbackUrl,
					isPopup: false,
					loginButton: { color: 'green', type: 3, height: 40 }
				});
				this.naverLogin.init();
			} else {
				// SDK가 아직 로드 안 됐으면 100ms 후 재시도
				setTimeout(initNaver, 3000);
			}
		};

		initNaver();

		// // 네이버 로그인 초기화
		// this.naverLogin = new (window as any).naver.LoginWithNaverId({
		// 	clientId: 'TODO:NAVER_CLIENT_ID',
		// 	callbackUrl: 'http://localhost:3000/naver-callback',
		// 	isPopup: false,
		// 	loginButton: { color: 'green', type: 3, height: 40 }
		// });
		// this.naverLogin.init();
	}

	handleKakaoLogin = () => {
		(window as any).Kakao.Auth.login({
			scope: 'profile_nickname,account_email',
			success: (authObj: any) => {
				console.log('카카오 인증 성공:', authObj);
				(window as any).Kakao.API.request({
					url: '/v2/user/me',
					success: (res: any) => {
						console.log('카카오 사용자 정보:', res);
						alert(`카카오 로그인 성공: ${res.kakao_account.profile.nickname}`);

						this.props.onLoginSuccess(authObj.access_token);
					},
					fail: (error: any) => console.error(error)
				});
			},
			fail: (err: any) => console.error('카카오 로그인 실패:', err)
		});
	};

	handleNaverLogin = () => {
		const btn = document.getElementById('naverIdLogin_loginButton');
		if (btn) btn.click();
	};

	handleGoogleLogin = () => {
		/* eslint-disable no-undef */
		(window as any).google.accounts.id.initialize({
			client_id: '206565291750-1tju9s42dto0h502f1d7lblu47e641sb.apps.googleusercontent.com',

			callback: (response: any) => {
				console.log('구글 로그인 성공:', response);
				const base64Url = response.credential.split('.')[1];
				const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
				const decoded = JSON.parse(atob(base64));
				console.log('구글 사용자 정보:', decoded);
				alert(`구글 로그인 성공: ${decoded.name}`);

				this.props.onLoginSuccess(response);
			},
			auto_select: false
		});
		(window as any).google.accounts.id.prompt();
	};

	render() {
		return (
			<div className="social-login-container">
				{/*<button className="btn-kakao" onClick={this.handleKakaoLogin}>*/}
				{/*	<img src="/images/kakao-icon.png" alt="Kakao" className="icon" />*/}
				{/*	카카오톡으로 로그인*/}
				{/*</button>*/}

				<div id="naverIdLogin" style={{ display: 'none' }}></div>
				<button className="btn-naver" onClick={this.handleNaverLogin}
						style={{
							backgroundImage: `url(${naverbtn})`,
						}}>
				</button>

				{/*<button className="btn-google" onClick={this.handleGoogleLogin}>*/}
				{/*	<img src="/images/google-icon.png" alt="Google" className="icon" />*/}
				{/*	구글로 로그인*/}
				{/*</button>*/}
			</div>
		);
	}
}

export default SocialLoginButtons;